import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  show: false,
  message: "",
  severity: "", // Can be "success", "error", "warning", "info"
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showToast: (state, action) => {
      state.show = true;
      state.message = action.payload.message;
      state.severity = action.payload.severity;
    },
    hideToast: (state) => {
      state.show = false;
      state.message = "";
      state.severity = "";
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;
